module.exports = __webpack_public_path__ + "img/doc_6.8fcbf85c.png";